import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Store from './store';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
//import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment';
import 'moment/locale/pt-br';


import ErrorsService from './core/error';

const errors: ErrorsService = new ErrorsService();

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
moment.locale("nb");

Vue.config.errorHandler = (error) => ErrorsService.instance.onError(error);
//https://www.digitalocean.com/community/tutorials/how-to-set-up-vue-js-authentication-and-route-handling-using-vue-router
//https://blog.sqreen.com/authentication-best-practices-vue/
//https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards




new Vue({
  
  router,
  data: new Store(),
  render: h => h(App)
}).$mount("#app");
